export const faqs = [
  {
    q: "513吃瓜是什么网站？",
    a: "513吃瓜是一个网络热梗聚合社区，主要整理热梗的来龙去脉、衍生表情包、二创二改作品和评论区神评。你不需要在多个平台之间来回跳，一次就能看完全部后续。",
  },
  {
    q: "网站上的内容多久更新一次？",
    a: "热梗追踪与评论区神评每天更新，表情包专区与二创合集每周整理两到三次。遇到突然刷屏的大梗，我们会当天加更一期。",
  },
  {
    q: "我可以投稿自己做的二创或表情包吗？",
    a: "当然可以。通过「联系我们」页面告诉我们作品的主题和链接即可，编辑会在一到两个工作日内回复。被收录的作品会标注创作者昵称。",
  },
  {
    q: "为什么有些梗我看的时候已经过气了？",
    a: "热梗的传播周期通常只有一周左右，从爆火到回落的节奏很快。我们会保留完整的传播记录，即使梗已经过气，来龙去脉依然可查。",
  },
  {
    q: "表情包可以随意保存使用吗？",
    a: "站内表情包均为网友公开传播的素材整理，日常聊天使用没有问题。若用于商业用途，建议先确认原始素材的授权情况，我们也会在页面标注来源。",
  },
  {
    q: "内容会不会有主观倾向？",
    a: "我们的内容原则是「只讲梗，不站队」。涉及具体个人时，我们只保留公开传播的公共信息，不做人身评价，也欢迎你通过联系方式指出不当之处。",
  },
  {
    q: "可以推荐我关注的梗吗？",
    a: "可以。把你觉得有意思的梗、出处和传播时间发给我们，我们会评估是否适合做成专题。被采纳的推荐会在专题末尾致谢。",
  },
  {
    q: "网站需要注册登录吗？",
    a: "目前不需要。浏览、筛选和查看详情都无需注册，我们也不会要求你提供任何个人隐私信息。",
  },
];